import { debounce, hasHorizontalScrollBar, hasVerticalScrollBar, animate } from '../functions.js';

const GRADIENT_MARGIN = 10;

/**
 * Usage:
 *  <scroll-gradient>
 *      <div>   <!-- This div should have overflow auto -->
 *          <div>Content</div>
 *          <div>Content</div>
 *          <div>Content</div>
 *          <div>Content</div>
 *          <div>Content</div>
 *      </div>
 *  </scroll-gradient>
 * 
 * Remember to add the CSS of .scroll-gradient
 * 
 * 2024-08-13: Fixes in refreshGradients
 */
export default class ScrollGradientElement extends HTMLElement {

    #scrollChild = null;
    #scrollStartDiv = null;
    #scrollEndDiv = null;

    connectedCallback() {

        this.classList.add('scroll-gradient');
        this.#scrollChild = this.firstElementChild;

        this.#scrollStartDiv = document.createElement('div');
        this.#scrollStartDiv.classList.add('scroll-gradient-start');

        this.#scrollEndDiv = document.createElement('div');
        this.#scrollEndDiv.classList.add('scroll-gradient-end');

        this.appendChild(this.#scrollStartDiv);
        this.appendChild(this.#scrollEndDiv);

        this.#scrollChild.addEventListener('scroll', debounce(() => {
            this.refreshGradients();
        }, 100));

        this.refreshGradients();
        
    }

    refreshGradients() {

        if (hasVerticalScrollBar(this.#scrollChild)) {

            this.classList.remove('scroll-gradient--horizontal');

            let diff = (this.#scrollChild.scrollHeight - this.#scrollChild.scrollTop) - this.#scrollChild.clientHeight;

            if (diff <= GRADIENT_MARGIN) {
                animate(this.#scrollEndDiv, {'opacity': 0}, 500);
            } else {
                animate(this.#scrollEndDiv, {'opacity': 1}, 500);
            }

            if (this.#scrollChild.scrollTop <= GRADIENT_MARGIN) {
                animate(this.#scrollStartDiv, {'opacity': 0}, 500);
            } else {
                animate(this.#scrollStartDiv, {'opacity': 1}, 500);
            }

        } else if (hasHorizontalScrollBar(this.#scrollChild)) {

            this.classList.add('scroll-gradient--horizontal');

            let diff = (this.#scrollChild.scrollWidth - this.#scrollChild.scrollLeft) - this.#scrollChild.clientWidth;

            if (diff <= GRADIENT_MARGIN) {
                animate(this.#scrollEndDiv, {'opacity': 0}, 500);
            } else {
                animate(this.#scrollEndDiv, {'opacity': 1}, 500);
            }

            if (this.#scrollChild.scrollLeft <= GRADIENT_MARGIN) {
                animate(this.#scrollStartDiv, {'opacity': 0}, 500);
            } else {
                animate(this.#scrollStartDiv, {'opacity': 1}, 500);
            }

        } else {
            animate(this.#scrollEndDiv, {'opacity': 0}, 500);
            animate(this.#scrollStartDiv, {'opacity': 0}, 500);
        }
    }
}

window.customElements.define('scroll-gradient', ScrollGradientElement);
